/*
 * @FileDescription:
 * @Author: 刘凯
 * @Date: 2022-02-25 14:32:52
 * @LastEditors: 陈旭
 * @LastEditTime: 2022-03-21 14:34:47
 */
import OpenCloseAll from '../components/open-close-all.vue';
import previewDownloadMixin from './preview-download-mixin';
import { checkImgExists, fetchPlayUrls } from '../utils';

export default {
  components: {
    OpenCloseAll
  },
  mixins: [previewDownloadMixin],
  props: {
    showLimit: {
      type: Number,
      default: 99
    },
    isEdit: Boolean,
    fileStatusHidden: Boolean,
    isManagement: {
      type: Boolean,
      default: true
    },
    attachmentItemWidth: {
      type: String,
      default: '188px'
    },
    attachmentItemHeight: {
      type: String,
      default: '106px'
    }
  },
  data() {
    return {
      open: false, // 是否展开全部
      showPage: false
    };
  },
  computed: {
    showFiles() {
      // TODO open 功能可以移动出去
      return this.open || this.isEdit ? this.files : this.files.slice(0, this.showLimit);
    },
    imgUrlList: ({ files }) => files.filter(f => f.fileType === 'image').map(f => f.viewUrl || f.url)
  },

  created() {
    this.showPage = false;
    this.files.forEach(file => {
      if (file.fileType === 'image') {
        checkImgExists(file.viewUrl).then(() => {}).catch(() => {
          checkImgExists(file.url).then(() => {
            this.$set(file, 'viewUrl', file.url);
          }).catch(async() => {
            if (!file.fileId) return;
            const result = await fetchPlayUrls(this.service, file.fileId, file.fileType);
            this.$set(file, 'viewUrl', result.data.datas[0].url);
          });
        });
      }
    });

    this.showPage = true;
  },
  methods: {
    previewImage(file) {
      if (!file.canPreview) return;
      let index = this.imgUrlList.findIndex(url => url === (file.viewUrl || file.url));
      this.$refs['viewImage'].index = index;
      this.$nextTick(() => {
        this.showImageViewer = true;
      });
      file.canPreview = false; // 预览结束后数据重置
    }
  }
};
